import { ActionButton, Flex, View, ViewProps } from "@adobe/react-spectrum";
import axios from "axios";
import { FC, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Question, setQuestions } from "store/slices/questions";
import { selectSpreadsheet } from "store/slices/spreadsheet";
import {
  selectAccessToken,
  setSelectedSheet as reduxSetSelectedSheet,
  getSelectedSheet,
} from "store/slices/credentials";

export const Picker: FC<ViewProps<6>> = (props) => {
  const dispatch = useDispatch();
  const spreadsheet = useSelector(selectSpreadsheet);
  const accessToken = useSelector(selectAccessToken);
  const reduxSheet = useSelector(getSelectedSheet);
  const [selectedSheet, setSelectedSheet] = useState<string | undefined>(
    undefined
  );

  useEffect(() => {
    if (selectedSheet) {
      axios
        .get(
          `https://sheets.googleapis.com/v4/spreadsheets/1smFPunWAknv47m6hMlD8N4HuBPVNGqJkW68ZYYwIOBc/values/${selectedSheet.replaceAll(
            /\//g,
            "%2F"
          )}%21A%3AC`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
              Accept: "application/json",
            },
          }
        )
        .then((data) => {
          const questions = generateQuestions(data.data.values);
          dispatch(setQuestions(questions));
        })
        .catch((err) => console.log(err));
    }
  }, [selectedSheet]);

  return (
    <View {...props}>
      <Flex justifyContent="space-around">
        {spreadsheet.sheets.map((sheet) => (
          <ActionButton
            key={sheet.properties.sheetId}
            onPress={() => {
              setSelectedSheet(sheet.properties.title);
              dispatch(reduxSetSelectedSheet(sheet.properties.title));
            }}
            UNSAFE_className={
              sheet.properties.title === selectedSheet ||
              sheet.properties.title === reduxSheet
                ? "selected"
                : "not-selected"
            }
          >
            {sheet.properties.title}
          </ActionButton>
        ))}
      </Flex>
    </View>
  );
};

function generateQuestions(data: string[][]): Question[] {
  const questions = [];

  let title = "";
  let author = "";
  for (let i = 2; i < data.length; i++) {
    let [currTitle, currAuthor, currQuestion] = data[i];

    if (currTitle && currAuthor) {
      title = currTitle;
      author = currAuthor;

      questions.push({ question: `Who wrote ${title}?`, answer: author });
    } else if (currQuestion) {
      questions.push({ question: currQuestion, answer: title });
    }
  }

  return shuffle<Question>(questions);
}

function shuffle<T>(starter: T[]): T[] {
  const array = structuredClone(starter);
  let currentIndex = array.length;

  // While there remain elements to shuffle...
  while (currentIndex != 0) {
    // Pick a remaining element...
    let randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex],
      array[currentIndex],
    ];
  }

  return array;
}
